/* eslint-disable react/prop-types */ // TODO: add props
import { OverlayTrigger, Popover } from 'react-bootstrap';
import _ from 'lodash';

const WarningIndicator = (props) => {
  const placement = props.placement || 'top';
  const icon = (
    <i className={`warning-indicator icon-exclamation-circle ${placement}`} />
  );

  return props.message ? (
    <OverlayTrigger
      placement="top"
      overlay={<Popover id={_.uniqueId()}>{props.message}</Popover>}
    >
      {icon}
    </OverlayTrigger>
  ) : (
    icon
  );
};

export default WarningIndicator;
